package fr.frux.feature.treedetail

import fr.frux.core.common.error.AppError
import fr.frux.shared.domain.model.AppliedCorrection
import fr.frux.shared.domain.model.Tree
import fr.frux.shared.domain.model.TreeCorrection
import fr.frux.shared.domain.model.TreeRevisionLog
import fr.frux.shared.domain.photos.TreePhotoUploads
import fr.frux.shared.domain.repository.SiteRepository
import fr.frux.shared.domain.repository.TreeCorrectionRepository
import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.flow.SharedFlow
import kotlinx.coroutines.flow.asSharedFlow
import kotlin.uuid.ExperimentalUuidApi
import kotlin.uuid.Uuid

/**
 * Dépendances d'édition de la fiche, groupées en un seul paramètre du ViewModel (detekt
 * LongParameterList). [newKey] tire les clés d'idempotence, pilotable en test. [sites] est nul dans les
 * constructions de test qui n'exercent pas le lien au lieu : la ligne « Lieu » reste alors vide.
 */
@OptIn(ExperimentalUuidApi::class)
class TreeDetailEditing(
    val corrections: TreeCorrectionRepository,
    val photoUploads: TreePhotoUploads,
    val newKey: () -> String = { Uuid.random().toString() },
    val sites: SiteRepository? = null,
)

/**
 * Corrections indisponibles, pour les constructions de test qui n'exercent pas l'édition : aucun
 * évènement, toute écriture en échec. Même patron que `NoOpTreeLocalDataSource`.
 */
internal object UnavailableTreeCorrections : TreeCorrectionRepository {
    override val applied: SharedFlow<AppliedCorrection> = MutableSharedFlow<AppliedCorrection>().asSharedFlow()

    override suspend fun correct(
        treeId: Long,
        correction: TreeCorrection,
        undo: TreeCorrection?,
        idempotencyKey: String,
    ): Result<Tree> = Result.failure(AppError.Unexpected(IllegalStateException("Corrections non câblées")))

    override suspend fun revisions(treeId: Long): Result<TreeRevisionLog> =
        Result.failure(AppError.Unexpected(IllegalStateException("Historique non câblé")))
}
